if (!customElements.get('select-modal')) {
  class SelectModal extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.toggleButton = this.querySelector('.modal-toggle');
      this.selectedOptions = this.querySelector('.selected--options');
      this.options = this.querySelectorAll('input');

      if (!this.toggleButton) return;
      this.onOutsideClickHandler = this.onOutsideClick.bind(this);
      this.onPageShowHandler = this.onPageShow.bind(this);

      this.initHandlers();
      this.syncSelectionState();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClickHandler);
      window.removeEventListener('pageshow', this.onPageShowHandler);
    }

    initHandlers() {
      this.toggleButton.addEventListener('click', this.toggleButtonClickHandler.bind(this));
      document.addEventListener('click', this.onOutsideClickHandler);
      window.addEventListener('pageshow', this.onPageShowHandler);
      this.addEventListener('keydown', this.keyDownHandler.bind(this));

      this.options.forEach((option) => {
        if (option.hasAttribute('data-all-options')) {
          option.addEventListener('change', this.inputValueDataOptionChange.bind(this));
        } else {
          option.addEventListener('change', this.inputValueChange.bind(this));
        }
      });
    }

    inputValueChange(e) {
      this.syncSelectionState();
    }

    inputValueDataOptionChange() {
      const mainOption = this.querySelector('[data-all-options]');
      if (mainOption && mainOption.checked) {
        this.querySelectorAll('input:not([data-all-options])').forEach((option) => {
          option.checked = false;
        });
      }

      this.syncSelectionState();
    }

    syncSelectionState() {
      const mainOption = this.querySelector('[data-all-options]');
      const selectedOptions = Array.from(this.querySelectorAll('input:not([data-all-options]):checked'));

      if (selectedOptions.length) {
        if (mainOption) {
          mainOption.checked = false;
        }
        this.selectedOptions.textContent = selectedOptions.map((opt) => opt.value).join(', ');
      } else {
        if (mainOption) {
          mainOption.checked = true;
        }
        this.selectedOptions.textContent = 'Any';
      }

      this.setAttribute('has-value', '');
    }

    onPageShow() {
      this.syncSelectionState();
    }

    keyDownHandler(e) {
      if (!this.classList.contains('open')) return;
      switch (e.key) {
        case 'Escape': {
          e.stopPropagation();
          this.classList.remove('open');
          break;
        }
        case 'Tab':
          {
            this.trapFocus(e);
            e.stopPropagation();
          }
          break;
        default:
      }
    }

    trapFocus(e) {
      if (document.activeElement == this.toggleButton && e.shiftKey) {
        this.options[this.options.length - 1].focus();
        e.preventDefault();
      } else if (document.activeElement == this.options[this.options.length - 1] && !e.shiftKey) {
        this.toggleButton.focus();
        e.preventDefault();
      }
    }

    onOutsideClick = (e) => {
      if (this.contains(e.target) || !this.classList.contains('open')) return;

      this.classList.remove('open');
    };

    toggleButtonClickHandler() {
      this.classList.toggle('open');
      this.toggleButton.setAttribute('aria-expanded', this.classList.contains('open'));
    }
  }

  customElements.define('select-modal', SelectModal);
}
